import { STORAGE_KEYS, readStored, removeStored, writeStored } from "@/lib/storage"

/**
 * "This browser probably has a session": a non-sensitive flag, never the
 * token, that only picks index.html's static first paint (Task 1.2,
 * carry-forward from 0.6). With it, the no-flash script shows the shell's
 * skeleton instead of the sign-in copy, so a returning user is not shown a
 * sign-in screen while the refresh cookie restores the session.
 *
 * Set on a sign-in and on each successful refresh; cleared whenever a session
 * ends or a refresh finds none. It decides nothing else: a stale flag costs
 * one skeleton frame before sign-in.
 */
const PRESENT = "1"

export function markSessionHint(): void {
  writeStored(STORAGE_KEYS.session, PRESENT)
}

export function clearSessionHint(): void {
  removeStored(STORAGE_KEYS.session)
}

export function hasSessionHint(): boolean {
  return readStored(STORAGE_KEYS.session) === PRESENT
}

/**
 * A sign-out whose `logout` did not reach the server (fix round 1): the
 * refresh cookie is still live, and the next boot's refresh would bring the
 * session back. The flag ("1", nothing secret) makes that boot send the
 * logout instead of refreshing. A sign-in drops it: the cookie is then the
 * new session's.
 */
export function markLogoutPending(): void {
  writeStored(STORAGE_KEYS.logoutPending, PRESENT)
}

export function clearLogoutPending(): void {
  removeStored(STORAGE_KEYS.logoutPending)
}

export function hasLogoutPending(): boolean {
  return readStored(STORAGE_KEYS.logoutPending) === PRESENT
}
